import pool from '../../../lib/db';
import fs from 'fs';
import path from 'path';

export const config = {
    api: {
        bodyParser: {
            sizeLimit: '10mb',
        },
    },
};

export default async function handler(req, res) {
    if (req.method === 'GET') {
        try {
            const [rows] = await pool.query('SELECT * FROM blogs ORDER BY created_at DESC');
            return res.status(200).json(rows);
        } catch (error) {
            console.error('Database GET Error:', error);
            return res.status(500).json({ error: 'Failed to fetch blogs from database.' });
        }
    }

    if (req.method === 'POST') {
        const { title, subtitle, description, content, image_url, image_base64, author, status, author_image, author_image_base64, author_role, author_bio, author_linkedin, author_twitter, author_socials } = req.body;

        if (!title || !content) {
            return res.status(400).json({ error: 'Title and content are required' });
        }

        let finalImageUrl = image_url || '';

        // Process Base64 Image Upload
        if (image_base64) {
            try {
                const uploadDir = path.join(process.cwd(), 'public', 'uploads');
                if (!fs.existsSync(uploadDir)) {
                    fs.mkdirSync(uploadDir, { recursive: true });
                }

                const matches = image_base64.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
                if (matches && matches.length === 3) {
                    const ext = matches[1] === 'jpeg' ? 'jpg' : matches[1];
                    const buffer = Buffer.from(matches[2], 'base64');
                    const fileName = `blog-${Date.now()}.${ext}`;
                    fs.writeFileSync(path.join(uploadDir, fileName), buffer);
                    finalImageUrl = `/projectbim/api/uploads/${fileName}`;
                }
            } catch (err) {
                console.error('Image Upload Error:', err);
            }
        }

        let finalAuthorImageUrl = author_image || '';
        if (author_image_base64) {
            try {
                const uploadDir = path.join(process.cwd(), 'public', 'uploads');
                if (!fs.existsSync(uploadDir)) {
                    fs.mkdirSync(uploadDir, { recursive: true });
                }

                const matches = author_image_base64.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
                if (matches && matches.length === 3) {
                    const ext = matches[1] === 'jpeg' ? 'jpg' : matches[1];
                    const buffer = Buffer.from(matches[2], 'base64');
                    const fileName = `author-${Date.now()}.${ext}`;
                    fs.writeFileSync(path.join(uploadDir, fileName), buffer);
                    finalAuthorImageUrl = `/projectbim/api/uploads/${fileName}`;
                }
            } catch (err) {
                console.error('Author Image Upload Error:', err);
            }
        }

        // Generate a URL-friendly slug
        const slug = title.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');

        try {
            const [result] = await pool.query(
                'INSERT INTO blogs (title, subtitle, description, slug, content, image_url, author, status, author_image, author_role, author_bio, author_linkedin, author_twitter, author_socials) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)',
                [title, subtitle || '', description || '', slug, content, finalImageUrl, author || 'Admin', status || 'published', finalAuthorImageUrl, author_role || '', author_bio || '', author_linkedin || '', author_twitter || '', JSON.stringify(author_socials || [])]
            );
            return res.status(201).json({ message: 'Blog created successfully', id: result.insertId });
        } catch (error) {
            console.error('Database POST Error:', error);
            if (error.code === 'ER_DUP_ENTRY') {
                return res.status(400).json({ error: 'A blog with this title already exists.' });
            }
            return res.status(500).json({ error: 'Failed to save the blog to the database.' });
        }
    }

    return res.status(405).json({ error: 'Method not allowed' });
}
